import React from 'react';
import PropTypes from 'prop-types';
import { defaultEnableBtnStyles } from '../lib/common';
import styles from '../styles/Accordion.module.scss';

export default function RaiseTicket({ handleTicketCreate, handlePostIssueClick }) {
  const showPostIssue = window.location.pathname.includes('genio');

  return (
    <section className="csraiseticket">
      <div className="raiseticketwrp text_center pt-40 pl-20 pr-20">
        <div className="font12 fw600 color777">Didn&apos;t get a solution to your concern?</div>
        <button
          type="button"
          className={`${styles.Accordion__Contant__Button} bluefill_animate font12 fw600 colorFFF mt-10`}
          style={defaultEnableBtnStyles}
          onClick={() => {
            handleTicketCreate();
          }}
        >
          Raise a Ticket
        </button>
        {showPostIssue && (
          <>
            <div className="font11 fw400 color777 mt-16">Help us to improve</div>
            <a
              tabIndex={0}
              role="button"
              onKeyDown={() => {}}
              className="clr007 font11"
              style={{ textDecoration: 'underline' }}
              onClick={() => {
                handlePostIssueClick();
              }}
            >
              Post an issue / Suggestion
            </a>
          </>
        )}
      </div>
    </section>
  );
}

RaiseTicket.propTypes = {
  handleTicketCreate: PropTypes.func,
  handlePostIssueClick: PropTypes.func,
};
